import { AddressType } from "@/types";
import { FLOOR_LEVELS } from "@/constants";

export const Address = ({ address }: { address: AddressType }) => {
  return (
    <div>
      {/* make this a link to google maps (use street, city, state and zipcode in the address link to google maps) */}

      <p className="text-sm">
        {address.name} {address.number && `#${address.number}`}
      </p>
      <p className="text-sm mt-2 underline underline-offset-4 decoration-yellow-500">
        <a
          href={`https://www.google.com/maps/search/?api=1&query=${address.street}, ${address.city}, ${address.state}, ${address.zipcode}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {address.street}
        </a>
      </p>
      <p className="text-sm">{address.city}</p>
      <p className="text-sm">
        {address.state} {address.zipcode}
      </p>
      <p className="text-sm mt-2">
        {address.floor !== null && (
          <div className="flex flex-row items-baseline gap-1">
            <div className="w-4 h-4 hidden">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                <path d="M384 64c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0 0 96c0 17.7-14.3 32-32 32l-96 0 0 96c0 17.7-14.3 32-32 32l-96 0 0 96c0 17.7-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0 0-96c0-17.7 14.3-32 32-32l96 0 0-96c0-17.7 14.3-32 32-32l96 0 0-96z" />
              </svg>
            </div>
            <p className="text-sm">
              ({FLOOR_LEVELS[address.floor as keyof typeof FLOOR_LEVELS]})
            </p>
          </div>
        )}
      </p>
    </div>
  );
};
